export const ALERT_STYLES = {
  vencido: { bg: "#FEF2F2", text: "#991B1B", border: "#FECACA", label: "Vencido" },
  red: { bg: "#FEF2F2", text: "#991B1B", border: "#FECACA", label: "< 7 días" },
  yellow: { bg: "#FFFBEB", text: "#92400E", border: "#FDE68A", label: "< 15 días" },
  orange: { bg: "#FFF7ED", text: "#9A3412", border: "#FED7AA", label: "< 30 días" },
};

export const ESTADO_STYLES = {
  activo: { bg: "#ECFDF5", text: "#065F46", border: "#A7F3D0", label: "Activo" },
  vencido: { bg: "#FEF2F2", text: "#991B1B", border: "#FECACA", label: "Vencido" },
  sin_stock: { bg: "#F1F5F9", text: "#475569", border: "#E2E8F0", label: "Sin stock" },
};

export function AlertChip({ level, dias }) {
  if (!level) {
    return <span className="text-[#64748B] text-xs">—</span>;
  }
  const s = ALERT_STYLES[level];
  const text =
    level === "vencido"
      ? `Vencido hace ${Math.abs(dias)}d`
      : `${dias}d restantes`;
  return (
    <span
      data-testid={`alert-chip-${level}`}
      className="inline-flex items-center gap-1 rounded-md px-2 py-1 text-xs font-bold"
      style={{ backgroundColor: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: s.text }} />
      {text}
    </span>
  );
}

export function EstadoChip({ estado }) {
  const s = ESTADO_STYLES[estado] || ESTADO_STYLES.activo;
  return (
    <span
      className="inline-flex items-center rounded-md px-2 py-1 text-xs font-semibold"
      style={{ backgroundColor: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      {s.label}
    </span>
  );
}
